/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-22 17:02:33
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-23 11:54:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAnimation/index.tsx
 */
import React from 'react';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import { dispatch } from 'src/store';
import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RouteBlock from '../SalesChannelEditorHeader/RouteBlock';
import {
  fetchAnimation,
  getAnimation,
  getAnimations,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getSubmitStamp,
  onAddAnimation,
  onCollapseOpen,
  onDelete,
  onDuplicate,
  onErrorChange,
  submitAnimation,
  validation,
} from './slice';

import { Button } from '@/src/components/Antd';
import ErrorProcessingComponent from '@/src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC/ErrorProcessingComponent';
import { useDispatch, useSelector } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Item from './Item';
import styles from './style.less';
import { animationValidation, convertDataFromReduxToServer } from './tool';
function SalesChannelEditorAnimation(props) {
  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    isOnPrimaryLanguage,
  } = props;

  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const animations = useSelector(getAnimations());
  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      <PageWrapper
        headerConfig={{
          hasModified: true,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName: salesChannelName,
          onDiscard,
          onGoBack,
        }}>
        <div className={styles.container}>
          <div className={styles.title}>
            {getI18n('general.sider.animation')}
          </div>
          <div className={styles.content}>
            {Array.isArray(animations) &&
              animations.map((animation) => {
                return (
                  <ErrorProcessingComponent
                    key={animation.uuid}
                    getCollapseOpenStatus={getCollapseOpenStatus}
                    onCollapseOpen={onCollapseOpen}
                    headerProps={{
                      dotsFunction: [
                        {
                          onClick: () => {
                            _d(onDuplicate({ uuid: animation.uuid }));
                          },
                          key: 'Duplicate',
                          body: 'Duplicate',
                        },
                        {
                          key: 'Delete',
                          body: 'Delete',
                          isDangerous: true,
                          displayWarningModal: true,
                          onClick: () => void 0,
                          modalOnOk: () => {
                            _d(onDelete({ uuid: animation.uuid }));
                          },
                          modalTitle: 'Delete Navigation',
                          modalContent: 'Are you sure to delete navigation ?',
                        },
                      ],
                      hasDots: true,
                      hideDotsWhenNotPrimary: true,
                    }}
                    id={animation.uuid}
                    expandOffset={0}
                    getContent={() => getAnimation(animation.uuid)}
                    title={animation.name}
                    getErrorDisplay={getCollapseValidationMsgDisplay}
                    onErrorChange={onErrorChange}
                    validation={(x, _p) => {
                      return animationValidation(x);
                    }}
                    getSubmitStamp={getSubmitStamp}
                    renderComponent={(errorProcessingProps: any) => (
                      <Item
                        animation={animation}
                        errorProcessingProps={errorProcessingProps}
                      />
                    )}
                  />
                );
              })}
          </div>
          <div className={styles.add}>
            {isOnPrimaryLanguage && (
              <Button type={'primary'} onClick={() => _d(onAddAnimation({}))}>
                {'Add Animation'}
              </Button>
            )}
          </div>
        </div>
      </PageWrapper>
    </React.Fragment>
  );
}

export default BasicPageHOC(SalesChannelEditorAnimation, {
  getState,
  convertDataFromReduxToServer,
  submit: submitAnimation,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  getLoaded,
  validation,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchAnimation({
        uuid: contentUuid,
      }),
    );
  },
});
